import { cn } from "../../lib/utils";

interface LeaderboardSkeletonProps {
  className?: string;
}

export function LeaderboardRankingSkeleton({ className }: LeaderboardSkeletonProps) {
  return (
    <div className={cn("flex items-center justify-between gap-2 rounded-[8px] border border-black bg-white px-3 py-2.5 shadow-[0_4px_0_0_#000000] animate-pulse", className)}>
      <div className="flex items-center gap-3">
        <div className="flex min-w-[48px] items-center justify-center">
          <div className="h-6 bg-gray-200 rounded w-6" /> {/* Rank */}
        </div>
        <div className="h-8 w-8 bg-gray-200 rounded-full" /> {/* Avatar */}
        <div className="space-y-1">
          <div className="h-3.5 bg-gray-200 rounded w-20" /> {/* Name */}
          <div className="h-2.5 bg-gray-200 rounded w-12" /> {/* Followers */}
        </div>
      </div>
      <div className="text-right space-y-1">
        <div className="h-4 bg-gray-200 rounded w-16" /> {/* Earnings */}
        <div className="h-2 bg-gray-200 rounded w-10 ml-auto" /> {/* PeriodLabel */}
      </div>
    </div>
  );
}

export function LeaderboardHighlightSkeleton({ className }: LeaderboardSkeletonProps) {
  return (
    <div className={cn("rounded-lg border border-black bg-white px-3 py-3 shadow-[0_4px_0_0_#000000] animate-pulse", className)}>
      <div className="flex items-end justify-between gap-4 text-center">
        {/* 2nd place */}
        <div className="flex flex-1 flex-col items-center gap-1 pb-0">
          <div className="h-12 w-12 bg-gray-200 rounded-full" />
          <div className="h-4 bg-gray-200 rounded w-16" />
          <div className="h-3 bg-gray-200 rounded w-12" />
        </div>
        {/* 1st place */}
        <div className="flex flex-1 flex-col items-center gap-1 pb-7">
          <div className="h-12 w-12 bg-gray-200 rounded-full" />
          <div className="h-4 bg-gray-200 rounded w-20" />
          <div className="h-3 bg-gray-200 rounded w-14" />
        </div>
        {/* 3rd place */}
        <div className="flex flex-1 flex-col items-center gap-1 pb-0">
          <div className="h-12 w-12 bg-gray-200 rounded-full" />
          <div className="h-4 bg-gray-200 rounded w-14" />
          <div className="h-3 bg-gray-200 rounded w-10" />
        </div>
      </div>
    </div>
  );
}

export function LeaderboardSummarySkeleton({ className }: LeaderboardSkeletonProps) {
  return (
    <div className={cn("space-y-3 rounded-lg border border-black bg-white px-4 py-4 shadow-[0_4px_0_0_#000000] animate-pulse", className)}>
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <div className="h-4 bg-gray-200 rounded w-16" /> {/* Rank label */}
          <div className="h-8 bg-gray-200 rounded w-20" /> {/* Rank value */}
        </div>
        <div className="text-right space-y-1">
          <div className="h-4 bg-gray-200 rounded w-24" /> {/* Earnings label */}
          <div className="h-8 bg-gray-200 rounded w-20 ml-auto" /> {/* Earnings value */}
        </div>
      </div>
      <div className="h-3 bg-gray-200 rounded w-2/3" /> {/* Message */}
      <div className="h-px w-full bg-[#EAECF0] mt-3" />
      <div className="flex items-start gap-2 pt-1.5">
        <div className="h-4 w-4 bg-gray-200 rounded mt-1" />
        <div className="space-y-1">
          <div className="h-4 bg-gray-200 rounded w-36" />
          <div className="h-3 bg-gray-200 rounded w-48" />
        </div>
      </div>
    </div>
  );
}
